import { Controller } from "react-hook-form";
import PhoneNumberInput, { Country } from "react-phone-number-input";

import { twMerge } from "tailwind-merge";

import ErrorTooltip from "../ErrorTooltip";

type ViewProps = Omit<
  React.ComponentProps<typeof PhoneNumberInput>,
  "onChange"
>;
type CustomProps = {
  label?: string;
  patternError?: string;
};

const countries: Country[] = ["NO", "SE", "GB", "DE"];

const PhoneInput = (props: ViewProps & CustomProps) => {
  const {
    id,
    control,
    name,
    label,
    minLength,
    patternError,
    regexPattern,
    required,
    validationFunction,
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        pattern: regexPattern,
        validate: validationFunction,
      }}
      render={({ field, fieldState: { error } }) => (
        <div className="flex flex-col">
          {label && (
            <label
              htmlFor={id}
              className="font-dm-sans text-sm font-medium text-black empty:hidden"
            >
              {label}
              {label && required && " *"}
            </label>
          )}
          <div className="relative flex-col">
            <PhoneNumberInput
              addInternationalOption
              className={twMerge(
                "border-px font-dm-sans disabled:border-grey3 disabled:text-grey6 border border-black px-2 text-sm",
                "focus:outline-2 focus:-outline-offset-2 focus:outline-solid",
                error &&
                  "border-carrot-red bg-light-peach focus:outline-carrot-red border",
              )}
              countries={countries}
              countryCallingCodeEditable
              countryOptionsOrder={countries}
              defaultCountry="NO"
              focusInputOnCountrySelection
              withCountryCallingCode
              international
              numberInputProps={{
                className: twMerge(
                  "h-[38px] border-none",
                  error && "bg-light-peach",
                ),
              }}
              {...field}
            />
            <ErrorTooltip
              label={label}
              patternError={patternError}
              minLength={minLength}
              error={error}
            />
          </div>
        </div>
      )}
    />
  );
};

export default PhoneInput;
